import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'
import HelloIntroBox from '../../../components/IntroBox'
import { GetSubscription } from '../../../store/SubscriptionClient'
import StripePortalButton from '../components/StripePortalButton'

import IPSALogo from '../../../assets/images/oneprotect_icon.png'

const AccountSidebar = ({ type = 'Account' }) => {
    const { user } = useAuth0()

    const [subscriptionInfo, setSubscriptionInfo] = useState({})

    useEffect(() => {
        GetSubscription().then((sub) => {
            setSubscriptionInfo(sub.data)
        })
    }, [])

    const { paymentSetup } = subscriptionInfo

    return (
        <div id="side-content">
            <HelloIntroBox user={user} type={type} />

            <ul className="button-list">
                <li>
                    <Link to="/dashboard" className="btn">
                        <img
                            id="back-icon"
                            src={IPSALogo}
                            alt="Back Icon"
                            height="35px"
                            style={{ margin: '-10px 0' }}
                        />{' '}
                        BACK TO PORTAL
                        <span></span>
                    </Link>
                </li>
                {paymentSetup === 'No' && (
                    <div className="border-box">
                        <h2>Someone else paying?</h2>

                        <p>
                            If someone else, like your manager, will be paying for your subscription
                            you can click the button below.
                        </p>
                        <p>
                            The button will bring you to a page where you can share the URL to who
                            will be paying and have them add a payment method to your subscription.
                        </p>
                        <p>
                            Just a note that the link will <i>expire after a short time</i> if not
                            used. If they tell you the link does not work you may need to send it
                            again.
                        </p>
                        <p>
                            When they add a payment method to your subscription, it will convert to
                            a paying account after your trial is over!
                        </p>

                        <div style={{ marginTop: '25px' }}>
                            <StripePortalButton buttonText="Go to payment URL" />
                        </div>
                    </div>
                )}
            </ul>
        </div>
    )
}

export default AccountSidebar
